export const isAuthenticated = (state: { isAuthenticated: any; }) => {
  return state.isAuthenticated;
};

export const getPartnerAgreement = (state: { user: any; }) => {
  return state.user.partnerAgreementId;
};

export const getUser = (state: { user: any; }) => {
  return state.user;
};
